import { BusEvents, metricsBus } from "@/common/buses";
import eventTracker from "./eventTracker";
import { FIREHOSE_EVENTS } from "./catalog";

const isEmbed = import.meta.env.REACT_APP_EVENT_SOURCE === "embed";

const subscribe = <K extends keyof BusEvents>(key: K) => {
  const event = FIREHOSE_EVENTS[key];

  if (!event || (isEmbed && !event.allowInEmbed)) {
    return;
  }

  metricsBus.on(key, async (payload) => {
    const pagePath = window.location.pathname;

    try {
      const properties = event.properties ? event.properties(payload) : {};

      if (properties === null) {
        return;
      }

      await eventTracker.send(event.name, properties, pagePath);
    } catch (err) {
      console.error(`EventsTracker: failed to build properties for ${event.name}.`, err);
    }
  });
};

(Object.keys(FIREHOSE_EVENTS) as (keyof BusEvents)[]).forEach(subscribe);
